import React from 'react';
import PropTypes from 'prop-types';

const Alert = (props) => {
    const { description } = props;

    return (
        <p>{ description }</p>
    );
};

Alert.propTypes = {
    description: PropTypes.string,
};

export default Alert;



// WEBPACK FOOTER //
// ./src/components/modals/types/AlertModal.js